import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useEstablishmentTags(establishmentId) {
    const queryReturnValues = useQuery(
        ["recipe-tags", { establishmentId }],
        inventoryClient.getEstablishmentRecipeTags,
        {
            staleTime: 1000 * 60 * 10
        }
    );

   return queryReturnValues;
}

export default useEstablishmentTags;